import React from 'react'
import StaffList from '../../components/staffdetailscomponents/StaffList'

const StaffDetailsList = () => {
    return <StaffList />
}

export default StaffDetailsList